import { useEffect, useRef } from 'react';
import { Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { getPatientsByPage } from 'store/thunks/patientsListThunks';
import { getPartners } from 'store/thunks/partnerThunks';
import useRoles from 'common/hooks/useRoles';

import PatientFilterButton from './components/PatientFilterButton';
import PatientsTable from './components/PatientsTable';
import FilterStatusBar from './components/FilterStatusBar';
import NewPatientButton from './components/NewPatientButton';

const PatientsList = () => {
  const dispatch = useDispatch();
  const hasAccess = useRoles();
  const location = useLocation();
  const currentPage = useSelector(({ patientsList }) => patientsList.currentPage);
  const partners = useSelector(({ auth, partner }) => partner[auth.currentTenantId]);
  const isEmptyPartners = isEmpty(partners);
  // TEMP: Hide the "New Patient" button temporarily due to current requirements
  const TEMP_HIDE_NEW_PATIENT_BUTTON = true;

  const hasCalledApiRef = useRef(false);
  const previousPathnameRef = useRef(location.pathname);

  useEffect(() => {
    document.title = 'Patients - SmartOS';
  }, []);

  useEffect(() => {
    if (previousPathnameRef.current !== location.pathname && location.pathname === '/patients') {
      hasCalledApiRef.current = false;
    }
    previousPathnameRef.current = location.pathname;

    if (!hasCalledApiRef.current) {
      hasCalledApiRef.current = true;
      dispatch(getPatientsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, location.pathname]);

  useEffect(() => {
    if (isEmptyPartners) {
      dispatch(getPartners());
    }
  }, [dispatch, isEmptyPartners]);

  return (
    <Grid container sx={{ px: 3, pt: 2 }} direction='column'>
      <Grid item container justifyContent='space-between'>
        <Typography component='h1' variant='h5'>
          Patients
        </Typography>

        <Grid item>
          <Grid container gap={2}>
            {hasAccess.createNewPatient && !TEMP_HIDE_NEW_PATIENT_BUTTON && <NewPatientButton />}
            <PatientFilterButton />
          </Grid>
        </Grid>
      </Grid>

      <Grid item sx={{ minHeight: 40 }} container alignItems='center'>
        <FilterStatusBar />
      </Grid>

      <Grid item>
        <PatientsTable />
      </Grid>
    </Grid>
  );
};

export default PatientsList;
